import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { apiRequest } from '@/shared/api'
import type { FileRef } from '@/shared/lib'

// Детали — партиал: присланное поле ставит значение, пустая строка очищает.
export interface MeetingDetailsPatch {
  title?: string
  when?: string
  location?: string
  participants?: string
  url?: string
  notes?: string
  customer_visible?: boolean
}

// type, а не interface: тело запроса должно подходить под index-signature
// `Record<string, unknown>` api-клиента (интерфейсы её не выводят).
export type EditMeetingVars = {
  details?: MeetingDetailsPatch
  // Вложения правятся диффом: контракт PATCH бэка не принимает полный список.
  add_attachments?: FileRef[]
  remove_attachments?: FileRef[]
}

// Встреча живёт и в ленте проекта, и в ленте компании — инвалидация плоская
// по namespace, плюс точечно карточка встречи.
function useInvalidate(meetingId: string) {
  const qc = useQueryClient()
  return () => {
    void qc.invalidateQueries({ queryKey: meetingKeys.all })
    void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
  }
}

export function useEditMeeting(meetingId: string) {
  const invalidate = useInvalidate(meetingId)
  return useMutation({
    mutationFn: (vars: EditMeetingVars) =>
      apiRequest({ method: 'PATCH', url: `/meetings/${meetingId}`, body: vars }),
    onSuccess: () => invalidate(),
  })
}

// Удаление жёсткое, с каскадом: комментарии, теги, слоты документов и файлы.
export function useDeleteMeeting(meetingId: string) {
  const invalidate = useInvalidate(meetingId)
  return useMutation({
    mutationFn: () => apiRequest({ method: 'DELETE', url: `/meetings/${meetingId}` }),
    onSuccess: () => invalidate(),
  })
}
